import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from 'react-router-dom'
import { CircularProgress } from "@mui/material";
import App from "./App";
import "./i18n";
import AppContext from "./AppContext";
import "./index.scss";

ReactDOM.render(
  <Suspense
    fallback={
      <div>
        <CircularProgress size={40} />
      </div>
    }
  >
    <AppContext>
      <React.StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.StrictMode>
    </AppContext>
  </Suspense>,
  document.getElementById("root")
);
